import { Flex, For, Link, Heading } from "@chakra-ui/react";
import ShadowBox from "@/components/partials/ShadowBox";
import revalidate from '@/lib/revalidate';

export default async function Readmore() {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/mais-lidas`, {
    next: revalidate('REVALIDATE_LATERAL_READMORE')
  });

  const result = await res.json();
  const { data: readmore } = result;

  return (
    <ShadowBox text="Mais Lidas"  padding="6">
      <Flex flexDirection="column">
          <For each={readmore} index="index">
              {(post, index) => (
                <Link
                  key={index}
                  href={post.postPermalink}
                  title={post.postTitle}
                  py="1"
                  borderBottom="2px solid" borderColor="gray.50" _last={{borderColor: 'white'}}
                  mb="4"
                  display="block"
                  >
                    <Flex flexDirection="column" mb="4" className="group" _hover={{}}>
                      <Heading as="h3" fontFamily="inherit" color="gray.600" fontSize="1.2em" fontWeight="300" lineHeight="1" _groupHover={{ color: 'blue.500'}}>
                        { post.postTitle }
                      </Heading>
                    </Flex>
                  </Link>
              )}
          </For>
      </Flex>
    </ShadowBox>
  )
}
